export type ProtectedRole = 'SURVEYOR' | 'ADMIN'

export const AUTH_ROUTE_NAME = 'auth-login' as const

export const normalizeAuthRedirect = (value: unknown, fallback = '/') => {
  const candidate = String(value || '')
  return candidate.startsWith('/') && !candidate.startsWith('//') ? candidate : fallback
}

export const roleAllows = (actualRole: unknown, requiredRole?: ProtectedRole) => {
  if (!requiredRole) return true
  return requiredRole === 'ADMIN'
    ? actualRole === 'ADMIN'
    : actualRole === 'SURVEYOR' || actualRole === 'ADMIN'
}

export const authLoginLocation = (
  redirect: string,
  role?: ProtectedRole,
  reason?: 'forbidden',
) => ({
  name: AUTH_ROUTE_NAME,
  query: {
    redirect: normalizeAuthRedirect(redirect),
    ...(role ? { role } : {}),
    ...(reason ? { reason } : {}),
  },
})
